import { render, staticRenderFns } from "./PerformanceDetailsModal.vue?vue&type=template&id=21a06f93&scoped=true"
import script from "./PerformanceDetailsModal.vue?vue&type=script&lang=js"
export * from "./PerformanceDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PerformanceDetailsModal.vue?vue&type=style&index=0&id=21a06f93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a06f93",
  null
  
)

export default component.exports